module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /home/dani/kaiwa/~/babel-runtime/core-js/json/stringify.js
// module id = 822
// module chunks = 2